var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { DirtyModel } from './DirtyModel';
import { DirtyProperty } from './DirtyProperty';
import { Inject } from '../Application';
import { Constants, Events, } from '../Contract';
import { ErrorCodes, ExceptionHandlerClass } from '../System/Aop';
var DirtyCache = (function () {
    function DirtyCache(inject) {
        if (inject === void 0) { inject = null; }
        var myInject = inject || Inject.Instance;
        this.items = Array();
        this.event = myInject.resolve(Constants.EventAggregator);
    }
    DirtyCache.prototype.change = function (model, property) {
        var _this = this;
        if (property && model.UniqueID && !model.isCoreSynchronizing()) {
            if (this.items.some(function (item) { return item.name === model.UniqueID; })) {
                this.items
                    .filter(function (item) { return item.name === model.UniqueID; })
                    .forEach(function (item) {
                    item.properties.push(new DirtyProperty(property, _this.getPropertyValue(model, property)));
                });
            }
            else {
                this.items.push(new DirtyModel(model.UniqueID, new Array(new DirtyProperty(property, this.getPropertyValue(model, property)))));
            }
        }
    };
    DirtyCache.prototype.init = function (entity) {
        this.entity = entity;
        this.setListener();
    };
    DirtyCache.prototype.getChanges = function () {
        var collection = {};
        while (this.items.length > 0) {
            var currentItem = this.items.pop();
            collection[currentItem.name] = currentItem.toReduce();
        }
        return collection;
    };
    DirtyCache.prototype.setListener = function () {
        var _this = this;
        this.event.subscribe(Events.Change, function (event) {
            return _this.change(event.model, event.property);
        });
    };
    DirtyCache.prototype.getPropertyValue = function (model, property) {
        var composedProperty = property.split('.');
        if (composedProperty.length === 1) {
            return model[property];
        }
        var result = new Map();
        result.set(0, model);
        for (var index = 0; index < composedProperty.length; index++) {
            var prevProp = result.get(index);
            result.set(index + 1, prevProp[composedProperty[index]]);
        }
        return result.get(result.size - 1);
    };
    DirtyCache.prototype.getPropertyName = function (property) {
        var composedProperty = property.split('.');
        if (composedProperty.length === 1) {
            return property;
        }
        else {
            return composedProperty[1];
        }
    };
    DirtyCache = __decorate([
        ExceptionHandlerClass(ErrorCodes.ClientCore),
        __metadata("design:paramtypes", [Object])
    ], DirtyCache);
    return DirtyCache;
}());
export { DirtyCache };
